<style scoped>
/* .border{
    border: 1px solid black !important;
  } */
</style>
<template>
  <div>
    <loader :loader="sending" />

    <div class="wrapper-content">
      <encabezado v-if="encabezado" :elementos="encabezado" :action="action" />
      <v-card>
        <v-card-text>
          <div
            name="table"
            v-if="showAction(1) && table"
            :class="[list.length < 6 ? 'mt-4' : 'mt-4 mb-6']"
          >
            <div class="border mb-5 pl-5 pr-5">
              <v-row class="my-content" dense>
                <v-col
                  cols="12"
                  sm="12"
                  md="3"
                  lg="3"
                  v-if="filterBranchOffice"
                >
                  <branch-offices-list
                    :model="idBranchOffice"
                    :dense="true"
                    v-on:triggerChange="branchOfficeSelected"
                  />
                </v-col>

                <v-col cols="12" :md="filterBranchOffice ? 9 : 12" sm="12">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    dense
                    hide-details
                    :clear-icon="$cnst.CLEAR_ICON"
                    clearable
                  />
                </v-col>
              </v-row>

              <transition name="fade">
                <v-row class="pt-4" dense>
                  <v-col cols="12" md="3" sm="12" v-if="this.history">
                    <v-autocomplete
                      v-model="status"
                      :items="statusList"
                      auto-select-first
                      clearable
                      label="Estatus"
                      dense
                      no-data-text="Sin resultados disponibles"
                      :clear-icon="$cnst.CLEAR_ICON"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="3" lg="3">
                    <v-autocomplete
                      v-model="idModality"
                      :items="modalities"
                      auto-select-first
                      label="Modalidad"
                      :clear-icon="$cnst.CLEAR_ICON"
                      clearable
                      dense
                      no-data-text="Sin resultados disponibles"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="3" lg="3">
                    <v-autocomplete
                      v-model="idStudyModality"
                      :items="studyProfiles"
                      auto-select-first
                      clearable
                      label="Perfil de estudio"
                      dense
                      :clear-icon="$cnst.CLEAR_ICON"
                      no-data-text="Sin resultados disponibles"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="3" lg="3">
                    <vc-date-picker
                      color="green"
                      v-model="range"
                      is-range
                      :max-date="new Date()"
                    >
                      <template v-slot="{ inputEvents }">
                        <v-text-field
                          v-on="inputEvents.start"
                          :value="rangeComputed"
                          :append-icon="
                            validData ? 'mdi-eraser' : 'mdi-calendar'
                          "
                          @click:append="clearCalendar"
                          dense
                          :disabled-input="validData"
                          label="Fecha..."
                          single-line
                          outlinedx
                          :clear-icon="$cnst.CLEAR_ICON"
                          hide-details
                        />
                      </template>
                    </vc-date-picker>
                  </v-col>
                  <v-col cols="2" class="justify-center" v-if="showFilter">
                    <v-tooltip top color="primary">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          @click="showFilter = !showFilter"
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon>mdi-filter-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Filtrar</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </transition>
            </div>

            <component
              class="mt-2"
              :key="tableKey"
              :get="get"
              :listAllPagination="listAllPagination"
              :idBranchOffice="idBranchOffice"
              :list="list"
              :is="table"
              :currentPage="currentPage"
              :range="range"
              :status="status"
              :idModality="idModality"
              :search="search"
              :totalCount="totalCount"
            />
            <v-row dense>
              <v-col cols="8" md="8" sm="8" offset="2" class="text-center">
                <paginatesx
                  :click-handler="changePage"
                  :page-count="pageCount"
                  :page-range="1"
                  :margin-pages="1"
                  :prev-text="'<'"
                  :next-text="'>'"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                >
                </paginatesx>
              </v-col>
              <v-col cols="12" md="2" sm="2" class="text-center mt-5">
                <v-banner outlined single-line>
                  Total: {{ totalCount.toLocaleString() }}</v-banner
                >
              </v-col>
            </v-row>
          </div>

          <div name="form" v-if="(showAction(2) || showAction(3)) && form">
            <validation-observer ref="observer" v-slot="{ invalid }">
              <v-form @submit.prevent="undefined">
                <component
                  :is="form"
                  key="form"
                  :model="model"
                  :modelDialog="modelDialog"
                  :idMedicalPractice="idMedicalPractice"
                  @returnTable="returnTable"
                  :saveFilesChanges="saveFilesChanges"
                  :buttonBirads="buttonBirads"
                  :mastography="mastography"
                  :isMammography="isMammography"
                />
                <div class="separator20-50"></div>
                <div class="text-center justify-center">
                  <v-col class="justify-space-around">
                    <v-menu
                      offset-x
                      bottom
                      left
                      :close-on-content-click="true"
                      rounded="lg"
                    >
                      <template v-slot:activator="{ on: menu, attrs }">
                        <v-btn
                          type="button"
                          :class="!showAction(3) ? 'mr-12 mb-4' : 'mb-4'"
                          :disabled="sending"
                          outlined
                          color="error"
                          depressed
                          v-bind="attrs"
                          v-on="{ ...menu }"
                          @click="confirmationReturn()"
                        >
                          <v-icon left> mdi-keyboard-backspace </v-icon>
                          Volver
                        </v-btn>
                      </template>
                    </v-menu>
                    <v-menu
                      v-if="!showAction(3)"
                      offset-x
                      bottom
                      rigth
                      :close-on-content-click="true"
                      rounded="lg"
                    >
                      <template v-slot:activator="{ on: menu, attrs }">
                        <v-btn
                          type="button"
                          class="mb-4"
                          :disabled="invalid"
                          v-bind="attrs"
                          depressed
                          v-on="{ ...menu }"
                          color="primary"
                          @click="confirmationSave()"
                        >
                          {{ saveButtonText }}
                          <v-icon right>mdi-content-save</v-icon>
                        </v-btn>
                      </template>
                    </v-menu>
                  </v-col>
                </div>
              </v-form>
            </validation-observer>
          </div>

          <div name="addenumViewer" v-if="showAction(4)">
            <component
              :is="addenumViewer"
              key="addenumViewer"
              :addendums="addendums"
            />
            <div class="separator20-50"></div>

            <div class="text-right justify-center">
              <v-col class="justify-space-around">
                <v-menu
                  offset-x
                  bottom
                  left
                  :close-on-content-click="true"
                  rounded="lg"
                >
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-btn
                      type="button"
                      class="mr-12 mb-4"
                      :disabled="sending"
                      outlined
                      color="error"
                      depressed
                      v-bind="attrs"
                      v-on="{ ...menu }"
                      @click="confirmationReturn()"
                    >
                      <v-icon left> mdi-close </v-icon>
                      volver
                    </v-btn>
                  </template>
                </v-menu>
              </v-col>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <v-dialog v-model="swalDialog" persistent></v-dialog>
      <!-- <v-dialog persistent v-model="addWithPDF">
          <component
            key="pdfModal"
            :is="pdfModal"
            :model="model"
            @returnTable="returnTable"
            :addWithPDF="addWithPDF"
          />
        </v-dialog> -->
    </div>
  </div>
</template>
<script>
import Encabezado from "@/app/components/base/header/Header.vue";
import Loader from "@/app/components/base/loader/Loader.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapState } from "vuex";
import BranchOfficesList from "@/components/BranchOfficesList.vue";
import { ModaltyRequest, StudyModalityRequest } from "@/core/request";

export default {
  name: "ImageView",
  components: {
    Loader,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    BranchOfficesList,
  },
  data() {
    return {
      showFilter: false,
      tableKey: 0,
      cols: "col-md-3 col-xl-3 col-sm-12",
      idBranchOffice: null,
      sending: false,
      dialog: false,
      index: -1,
      action: 1,
      list: [],
      model: {},
      modelDialog: {},
      statusList: [],
      encabezado: null,
      table: null,
      service: null,
      form: null,
      addenumViewer: null,
      cancelationDialog: null,
      search: null,
      totalCount: 0,
      currentPage: 1,
      itemsPerPage: 10,
      searchDelay: null,
      pageCount: 1,
      hideButtonAdd: false,
      filterBranchOffice: false,
      cancelationModal: false,
      generatePDFModal: false,
      saveButtonText: "",
      addButtonText: "",
      range: null,
      idBranchOffice: null,
      idMedicalPractice: "",
      saveFilesChanges: false,
      swalDialog: false,
      idModality: null,
      status: null,
      modalities: [],
      speciality: 2,
      buttonBirads: false,
      mastography: false,
      files: undefined,
      history: false,
      addendums: [],
      isMammography: false,
      studyProfiles: [],
      idStudyModality: null,
      parameters: {},
    };
  },
  watch: {
    search(newValue, oldValue) {
      this.deleteSearchDelay();
      this.searchDelay = setTimeout(() => {
        this.currentPage = 1;
        this.listAllPagination();
      }, 400);
    },
    idBranchOffice() {
      this.listAllModalities();
      this.listAllStudiesProfile();
      this.listAllPagination();
    },
    idModality() {
      this.listAllStudiesProfile();
      this.listAllPagination();
    },
    idStudyModality() {
      this.listAllPagination();
    },
    status() {
      this.listAllPagination();
    },
    idBranchOfficeState() {},
  },

  async mounted() {
    this.service = (await this.$route.meta.service()).default;
    this.table = (await this.$route.meta.table()).default;
    this.form = (await this.$route.meta.form()).default;

    if (this.$route.meta.addenumViewerFlag) {
      this.addenumViewer = (await this.$route.meta.addenumViewer()).default;
    }
    this.encabezado = this.$route.meta.header;
    this.filterBranchOffice = this.$utilFront.withBranchOffices() || false;

    this.hideButtonAdd = this.$route.meta.hideButtonAdd || false;
    this.cancelationModal = this.$route.meta.cancelationModal || false;
    this.generatePDFModal = this.$route.meta.generatePDFModal || false;
    this.history = this.$route.meta.history || false;
    this.saveButtonText = this.$route.meta.saveButtonText || "guardar";
    this.addButtonText = this.$route.meta.addButtonText || "Agregar";
    this.listAllPagination();
    this.listAllModalities();
    this.listAllStudiesProfile();
    this.listStatus();
  },
  computed: {
    ...mapState(["idBranchOfficeState"]),

    rangeComputed() {
      if (
        this.range === null ||
        this.range === "" ||
        this.range === undefined
      ) {
        return "";
      }
      return `Del ${this.$utilFront.formatDate(
        this.range.start
      )} al ${this.$utilFront.formatDate(this.range.end)}`;
    },
    validData() {
      if (this.range == "" || this.range == null || this.range == undefined) {
        return false;
      }
      this.listAllPagination();
      return true;
    },
  },

  methods: {
    listStatus() {
      if (this.history) {
        this.statusList = this.$cnst.statusNameStudies
          .filter((item) => item.modules.includes(this.$route.name))
          .map((item) => {
            return { value: item.status, text: item.name };
          });
      }
    },
    listAllModalities() {
      const idBranchOffice = this.$utilFront.nonEmpty(
        this.idBranchOffice,
        this.$utilFront.getIdBranchOffice()
      );

      const parameters = {
        idBranchOffice,
        idSpeciality: this.$cnst.SPECIALITY_IMAGE,
      };

      const handleResponse = ({ data }) => {
        const { data: modalitiesData } = data;

        if (
          this.$utilFront.validResponse(data) &&
          this.$utilFront.nonEmptyList(modalitiesData)
        ) {
          this.modalities = modalitiesData.map(
            ({ acronym, name, idModality }) => ({
              text: `${acronym ? acronym + " - " : ""}${name}`,
              value: idModality,
            })
          );
        } else {
          this.modalities = [];
        }

        if (this.$utilFront.nonEmptyList(this.modalities)) {
          this.modalities.sort((a, b) => a.text.localeCompare(b.text));

          if (this.$utilFront.nonEmpty(this.idModality)) {
            const searched = this.modalities.find(
              ({ value }) => value === this.idModality
            );
            if (this.$utilFront.isNull(searched)) {
              this.idModality = null;
            }
          }
        } else {
          this.idModality = null;
        }
      };

      if (this.history) {
        ModaltyRequest.listModaltyByBranchOfficeAndSpecialty(parameters).then(
          handleResponse
        );
      } else {
        ModaltyRequest.listModaltyByHumanResourceAndSpecialty(parameters).then(
          handleResponse
        );
      }
    },
    listAllStudiesProfile() {
      const idBranchOffice = this.$utilFront.nonEmpty(
        this.idBranchOffice,
        this.$utilFront.getIdBranchOffice()
      );
      const idSpeciality = this.$cnst.SPECIALITY_IMAGE;

      const idModality = this.$utilFront.nonEmpty(this.idModality)
        ? this.idModality
        : null;

      const handleResponse = ({ data }) => {
        const { code, status, data: studyModalitiesData } = data;

        if (
          code === 200 &&
          status === "OK" &&
          this.$utilFront.nonEmptyList(studyModalitiesData)
        ) {
          this.studyProfiles = studyModalitiesData.map(
            ({ acronym, name, idStudyModality }) => ({
              text: `${acronym ? acronym + " - " : ""}${name}`,
              value: idStudyModality,
            })
          );
        } else {
          this.studyProfiles = [];
        }

        if (this.$utilFront.nonEmptyList(this.studyProfiles)) {
          this.studyProfiles.sort((a, b) => a.text.localeCompare(b.text));

          if (this.$utilFront.nonEmpty(this.idStudyModality)) {
            const searched = this.studyProfiles.find(
              ({ value }) => value === this.idStudyModality
            );
            if (this.$utilFront.isNull(searched)) {
              this.idStudyModality = null;
            }
          }
        } else {
          this.idStudyModality = null;
        }
      };

      if (this.history) {
        StudyModalityRequest.findAllByModalityAndBranchOfficeAndSpeciality(
          idModality,
          idSpeciality,
          idBranchOffice
        ).then(handleResponse);
      } else {
        StudyModalityRequest.listStudyModalityBySpecialityAndUser(
          idSpeciality,
          idModality
        ).then(handleResponse);
      }
    },

    confirmationReturn() {
      this.swalDialog = true;
      this.$swal({
        toast: true,
        title: "¿Desea regresar a la vista principal?",
        text: "",
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.swalDialog = false;
          this.buttonBirads = false;
          this.changeAction(1);
        } else {
          this.swalDialog = false;
        }
      });
    },
    confirmationSave() {
      this.saveFilesChanges = true;
      this.swalDialog = true;
      this.$swal({
        toast: true,
        title: "¿Desea guardar la interpretación actual?",
        text: "",
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.saveFilesChanges = false;
          this.swalDialog = false;
          this.doAction();
        } else {
          this.swalDialog = false;
        }
      });
    },
    branchOfficeSelected(selected) {
      this.idBranchOffice = selected;
    },
    returnTable(e) {
      if (e) {
        this.changeAction(1);
        this.buttonBirads = false;
      }
    },
    showAction(action) {
      return this.action == action;
    },
    changeAction(action) {
      if (action == 1) {
        this.mastography = false;
        this.model = {};

        this.action = action;
        if (this.action != 2) {
          this.listAllPagination();
        }
      } else {
        this.action = action;
      }
    },
    doAction() {
      switch (this.action) {
        case 2:
          this.add();
          break;
        case 3:
          this.update();
          break;
        default:
          break;
      }
    },
    changePage(page) {
      if (this.currentPage != page) {
        this.currentPage = page;
        this.listAllPagination();
      }
    },
    deleteSearchDelay() {
      if (this.searchDelay != null) {
        clearTimeout(this.searchDelay);
        this.searchDelay = null;
      }
    },
    listAllPagination() {
      const idBranchOffice = this.$utilFront.nonEmpty(
        this.idBranchOffice,
        this.$utilFront.getIdBranchOffice()
      );

      let params = {
        status: this.status,
        search: this.search,
        maxResults: this.itemsPerPage,
        page: this.currentPage,
        idBranchOffice: idBranchOffice,
      };
      if (this.$utilFront.nonEmpty(this.range)) {
        params.start = this.$utilFront.startOfDay(this.range.start);
        params.end = this.$utilFront.endOfDay(this.range.end);
      }
      if (this.$utilFront.nonEmpty(this.idModality)) {
        params.idModality = this.idModality;
      }
      if (this.$utilFront.nonEmpty(this.idStudyModality)) {
        params.idStudyModality = this.idStudyModality;
      }

      this.parameters = params;
      this.sending = true;
      this.service
        .listAllPagination(params)
        .then((res) => {
          this.sending = false;
          let { list, count } = res.data;

          this.list = list.map((obj) => ({
            ...obj,
          }));

          this.totalCount = count;
          this.pageCount = Math.ceil(count / this.itemsPerPage);
          if (!this.history) {
            this.tableKey += 1;
          }

          if (
            (count > 0 &&
              this.$utilFront.isEmptyList(list) &&
              this.currentPage > 1) ||
            this.currentPage > this.pageCount
          ) {
            this.changePage(1);
          }
        })
        .catch((e) => {
          this.sending = false;
          this.$utilFront.errorhttp(e);
        });
    },
    add() {
      if (!this.sending) {
        this.sending = true;
        let data;
        if (!this.buttonBirads) {
          data = {
            interpretation: this.model.interpretation,
            complement: this.model.complement,
            idStudy: this.model.idStudy,
            idHumanResource: this.$utilFront.getIdHumanResource(),
            addendumList: this.model.filesList,
          };
        } else {
          data = {
            interpretation: this.model.interpretation,
            complement: this.model.complement,
            idStudy: this.model.idStudy,
            idHumanResource: this.$utilFront.getIdHumanResource(),
            idBirads: this.modelDialog.birads,
            note: this.modelDialog.note,
            addendumList: this.model.filesList,
            findingLocationTypeList: this.modelDialog.findingLocationTypeList,
          };
        }

        if (data && data.complement && data.complement.referenceDate) {
          data.complement.referenceDate = this.$utilFront.endOfDay(
            new Date(data?.complement?.referenceDate)
          );
        }

        this.service
          .add(data)
          .then((response) => {
            this.sending = false;
            let { data, code } = response.data;
            if (code == 200) {
              this.listAllPagination();
              this.$utilFront.notifications(
                "Se ha atendido correctamente.",
                "SUCCESS"
              );
              this.changeAction(1);
            } else {
              data = data || "Ocurrió un error durante el registro.";
              this.$utilFront.notifications(data, "ERROR");
            }
          })
          .catch((e) => {
            this.$utilFront.errorhttp(e);
          })
          .finally(() => {
            this.sending = false;
          });

        // .catch((e) => {
        //   this.sending = false;
        //   this.$utilFront.errorhttp(e);
        // });
      }
    },
    update() {
      if (!this.sending) {
        this.sending = true;
        let data;
        if (!this.buttonBirads) {
          data = {
            interpretation: this.model.interpretation,
            complement: this.model.complement,
            idStudy: this.model.idStudy,
            idInterpretation: this.model.idInterpretation,
            idHumanResource: this.$utilFront.getIdHumanResource(),
            addendumList: this.model.filesList,
          };
        } else {
          data = {
            interpretation: this.model.interpretation,
            complement: this.model.complement,
            idStudy: this.model.idStudy,
            idInterpretation: this.model.idInterpretation,
            idHumanResource: this.$utilFront.getIdHumanResource(),
            idBirads: this.modelDialog.birads,
            note: this.modelDialog.note,
            addendumList: this.model.filesList,
            findingLocationTypeList: this.modelDialog.findingLocationTypeList,
          };
        }

        if (data && data.complement && data.complement.referenceDate) {
          data.complement.referenceDate = this.$utilFront.endOfDay(
            data?.complement?.referenceDate
          );
        }

        this.service
          .update(data)
          .then((response) => {
            this.sending = false;
            let { data, code } = response.data;
            if (code == 200) {
              this.listAllPagination();
              this.$utilFront.notifications(
                "Se ha modificado correctamente.",
                "SUCCESS"
              );
              this.changeAction(1);
              // this.index = -1;
            } else {
              data = data || "Ocurrió un error durante la modificación.";
              this.$utilFront.notifications(data, "ERROR");
            }
          })
          .catch((e) => {
            this.$utilFront.errorhttp(e);
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
    get(params, i) {
      this.model = {};
      this.dataModal = Object.assign(this.model, params);
      this.changeAction(i);
    },
    clearCalendar() {
      this.range = {};
      this.listAllPagination();
    },
  },
};
</script>
